<template>

  <el-main
    class="main_content"
    style="padding: 0"
  >
    <div class="cont_navs_header">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>
          <a @click="jumpTo('/goodList')">商品管理</a>
        </el-breadcrumb-item>
        <el-breadcrumb-item>
          <a>sku列表</a>
        </el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="contain_div">
      <ul
        v-if="goodName != null"
        class="cont_btns1"
      >
        <li>
          <el-button
            @click="goBack"
            type="primary"
          >返回商品列表</el-button>
        </li>
      </ul>
      <div class="contain_header clr">
        <el-form
          :inline="true"
          class="m-search"
          size='small'
          :model="filters"
        >

          <el-form-item
            v-if="goodName != null"
            label='名称'
          >
            <el-tag type="success">{{goodName}}</el-tag>
          </el-form-item>
          <el-form-item
            v-if="goodName == null"
            label='商品名称'
          >
            <el-input
              clearable
              style="width:200px"
              v-model="filters.keyword"
              placeholder="请输入商品名称"
            >
            </el-input>
          </el-form-item>
          <el-form-item label="库存状态">
            <el-select
              v-model="filters.num_status"
              placeholder="请选择"
              clearable
            >
              <el-option
                label="库存正常"
                value="2"
              ></el-option>
              <el-option
                label="库存不足"
                value="1"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="上架状态">
            <el-select
              v-model="filters.status"
              placeholder="请选择"
              clearable
            >
              <el-option
                label="待上架"
                value="1"
              ></el-option>
              <el-option
                label="已上架"
                value="2"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button
              type="primary"
              @click="handleSearch"
            >搜索</el-button>
            <el-button
              v-if="goodName != null"
              type="success"
              @click="addPostDialog(null)"
            >新增</el-button>
          </el-form-item>
        </el-form>
      </div>

      <div class="contain_body">
        <div class="contain_body_head">
        </div>
        <el-table
          :data="tableData"
          :height="tableHeight"
          style="width: 100%"
          :header-cell-class-name='objectSpanMethod'
        >
          <el-table-column
            prop="id"
            label="编号"
          >
          </el-table-column>
          <el-table-column
            label="商品名称"
            prop="good_name"
          >
          </el-table-column>
          <el-table-column
            label="sku属性"
            prop="propertyN"
          >
          </el-table-column>
          <el-table-column
            label="团购价"
            prop="good_price"
          >
          </el-table-column>
          <el-table-column
            label="代理价"
            prop="proxy_price"
          >
          </el-table-column>
          <el-table-column
            label="库存"
            prop="good_num"
          >
          </el-table-column>
          <el-table-column
            label="触底数量"
            prop="low_num"
          >
          </el-table-column>
          <el-table-column
            prop="status"
            label="上架状态"
          >
            <template slot-scope="scope">

              <el-tag
                v-if="scope.row.status == 1"
                type="success"
                disable-transitions
              >待上架</el-tag>
              <el-tag
                v-if="scope.row.status == 2"
                type="info"
                disable-transitions
              >已上架</el-tag>
            </template>
          </el-table-column>
          <el-table-column
            label="操作"
            width="100"
          >
            <template slot-scope="scope">
              <el-button
                v-if="scope.row.status == 1"
                @click="upHouseStatus(scope.row, 2)"
                type="text"
                size="small"
              >上架</el-button>
              <el-button
                v-if="scope.row.status == 2"
                @click="upHouseStatus(scope.row, 1)"
                type="text"
                size="small"
              >取消上架</el-button>
              <el-button
                @click="addPostDialog(scope.row)"
                type="text"
                size="small"
              >编辑</el-button>
              <el-button
                @click="upHouseStatus(scope.row, 3)"
                type="text"
                size="small"
              >删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="pageDiv block">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="page_num"
            :page-count='total_page'
            :page-size="page_size"
            layout="total, prev, pager, next"
            :total="total_num"
          >
          </el-pagination>
        </div>
      </div>

    </div>

    <el-dialog
      title="修改规格"
      :visible.sync="dialogEditVisible"
      width="40%"
    >

      <el-form
        label-position="top"
        class="m-search"
        size='small'
        :model="form"
        ref="form"
        :rules="addFormRule"
      >
        <el-form-item
          label="规格名称"
          prop='property'
        >
          <el-input v-model="form.property"></el-input>
        </el-form-item>
        <el-form-item
          label="上架状态"
          prop="status"
        >
          <el-select
            v-model="form.status"
            placeholder="请选择"
          >
            <el-option
              v-for="option in options"
              :value="option.value"
              :key='option.value'
              :label="option.text"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            @click="editPost()"
            :loading="addLoading"
          >修改</el-button>
          <el-button @click="dialogEditVisible = false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

    <!-- <el-dialog
      title="新增sku"
      :visible.sync="dialogAddVisible"
      width="80%"
    >

      <el-form
        label-position="top"
        class="m-search"
        size='small'
        :model="form"
        ref="form"
        :rules="addFormRule"
      >
        <el-form-item
          label="商品名称"
          prop='goodName'
        >
          <el-input v-model="form.goodName"></el-input>
        </el-form-item>

        <div class="pri-div">
          <div class="guii-list">
            <div>
              <div class="guide-name">颜色</div>
              <el-checkbox-group v-model="checkList">
                <el-checkbox label="复选框 A"></el-checkbox>
                <el-checkbox label="复选框 B"></el-checkbox>
                <el-checkbox label="复选框 C"></el-checkbox>

              </el-checkbox-group>
            </div>
            <div>
              <div class="guide-name">颜色</div>
              <el-checkbox-group v-model="checkList">
                <el-checkbox label="复选框 A"></el-checkbox>
                <el-checkbox label="复选框 B"></el-checkbox>
                <el-checkbox label="复选框 C"></el-checkbox>

              </el-checkbox-group>
            </div>
          </div>

          <div class="guide-list">
            <div class="guide-head">
              <span>颜色</span>
              <span>尺寸</span>
              <span style="width:100px">价格</span>
              <span style="width:100px">库存</span>
              <span>操作</span>
            </div>
            <div>
              <span>红色</span>
              <span>1.2</span>
              <div>
                <el-input
                  clearable
                  style="width:100px"
                  v-model="filters.keyword"
                  placeholder="请输入"
                >
                </el-input>
              </div>
              <div>
                <el-input
                  clearable
                  style="width:100px"
                  v-model="filters.keyword"
                  placeholder="请输入"
                >
                </el-input>
              </div>
              <div>
                <el-button
                  @click="upHouseStatus(1, 3)"
                  type="text"
                  size="small"
                >删除</el-button>
              </div>
            </div>

            <div>
              <span>红色</span>
              <span>1.2</span>
              <div>
                <el-input
                  clearable
                  style="width:100px"
                  v-model="filters.keyword"
                  placeholder="请输入"
                >
                </el-input>
              </div>
              <div>
                <el-input
                  clearable
                  style="width:100px"
                  v-model="filters.keyword"
                  placeholder="请输入"
                >
                </el-input>
              </div>
              <div>
                <el-button
                  @click="upHouseStatus(1, 3)"
                  type="text"
                  size="small"
                >删除</el-button>
              </div>
            </div>

          </div>


        </div>

        <el-form-item>
          <el-button
            type="primary"
            @click="addPost()"
            :loading="addLoading"
          >新增</el-button>
          <el-button @click="dialogAddVisible = false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog> -->

  </el-main>
</template>


<script>
import { bus } from "../../bus.js";
import API from "../../api/api_user";
export default {
  name: "skuList",
  created() {
    this.goodName = this.$route.query.goodName;
    this.goodId = this.$route.query.goodId;
  },
  data() {
    return {
      addFormRule: {
        property: [
          { required: true, message: "请输入规格名称", trigger: "blur" }
        ],
        status: [{ required: true, message: "请选择上架状态", trigger: "blur" }]
      },
      addLoading: false,
      loading: false,
      goodName: null,
      goodId: null,
      form: {
        goodName: null,
        status: null,
        property: null,
        id: null
      },
      dialogPics: [],
      dialogEditVisible: false,
      dialogContent: "",
      dialogTitle: "",
      dialogVisible: false,
      filters: {
        num_status: null,
        status: null,
        keyword: null,
        pid: null
      },
      isCollapse: true,
      activeName: "second",
      dialogAddVisible: false,
      backFirst: 1,
      page_num: 1,
      keywords: "",
      value4: "",
      pickerOptions1: 1,
      value2: "",
      options: [{ text: "待上架", value: "1" }, { text: "上架", value: "2" }],
      typeOptions: null,
      tableData: [],
      total_num: 0,
      total_page: 0,
      page_size: 10,
      tableHeight:null
    };
  },
  mounted() {
    this.tableHeight = document.documentElement.clientHeight - 330;
    this.page_num = 1;
    this.handleSearch();
  },
  methods: {
    goBack() {
      this.$router.push({
        path: "/goodList"
      });
      this.defaultActiveIndex = "/goodList";
      this.$store.commit("jumpTo", "/goodList");
    },
    addPost() {
      let that = this;
      that.$refs["form"].validate(valid => {
        if (valid) {
          let para = Object.assign({}, that.form);
          para.token = localStorage.getItem("api_token");
          that.addLoading = true;
          API.add_good_sku(para)
            .then(
              function(result) {
                that.$refs["form"].resetFields();
                if (result.key == 1000) {
                  that.$message.success({
                    showClose: true,
                    message: "新增成功",
                    duration: 1500
                  });
                  that.dialogAddVisible = false;
                  that.addLoading = false;
                  that.search();
                } else {
                  that.$message.error({
                    showClose: true,
                    message: result.message || "登录失败",
                    duration: 2000
                  });
                }
              },
              function(err) {
                that.dialogAddVisible = false;
                that.addLoading = false;
                that.$message.error({
                  showClose: true,
                  message: err.toString(),
                  duration: 2000
                });
              }
            )
            .catch(function(error) {
              that.dialogAddVisible = false;
              that.addLoading = false;
              that.$message.error({
                showClose: true,
                message: "请求出现异常",
                duration: 2000
              });
            });
        }
      });
    },
    showSecond(row) {
      this.$router.push({
        path: "/goodGuidePropertyList",
        query: {
          id: row.id
        }
      });
    },
    editPost() {
      var that = this;
      let para = Object.assign({}, that.form);
      para.token = localStorage.getItem("api_token");
      this.addLoading = true;
      API.up_good_sku(para)
        .then(
          function(result) {
            if (result.key == 1000) {
              that.$message.success({
                showClose: true,
                message: "修改成功",
                duration: 1500
              });
              that.dialogEditVisible = false;
              that.addLoading = false;
              that.search();
            } else {
              that.$message.error({
                showClose: true,
                message: result.message || "登录失败",
                duration: 2000
              });
            }
          },
          function(err) {
            that.dialogEditVisible = false;
            that.addLoading = false;
            that.$message.error({
              showClose: true,
              message: err.toString(),
              duration: 2000
            });
          }
        )
        .catch(function(error) {
          that.dialogEditVisible = false;
          that.addLoading = false;
          that.$message.error({
            showClose: true,
            message: "请求出现异常",
            duration: 2000
          });
        });
    },
    addPostDialog(row) {
      var that = this;
      if (!row || row == null) {
        this.$router.push({
          path: "/addSku",
          query: {
            goodId: that.goodId,
            goodName: that.goodName,
            total:2
          }
        });
      } else {
        if (that.goodId && that.goodId != null) {
          this.$router.push({
            path: "/addSku",
            query: {
              goodId: that.goodId,
              goodName: that.goodName,
              judge: row,
              total:2
            }
          });
        } else {
          this.$router.push({
            path: "/addSku",
            query: {
              goodId: row.good_id,
              goodName: row.good_name,
              judge: row,
              total:1
            }
          });
        }
      }

      // this.form.goodName = this.goodName;
      // this.form.property = null;
      // this.form.status = "1";
      // this.dialogAddVisible = true;
    },
    editPostDialog(row) {
      this.form.id = row.id;
      this.form.status = row.status.toString();
      this.form.property = row.property;
      this.dialogEditVisible = true;
    },
    upHouseStatus(row, status) {
      let that = this;
      var m1 = "";
      var m2 = "";
      var m3 = "";
      var type = "";
      if (status == 1) {
        m1 = "确定取消上架该规格吗？";
        m2 = "取消成功后，app就不显示该规格";
        m3 = "取消成功";
        type = "warning";
      } else if (status == 2) {
        m1 = "确定上架该规格吗？";
        m2 = "上架成功后，app就会显示该规格";
        m3 = "上架成功";
        type = "success";
      } else {
        m1 = "确定删除该规格吗？";
        m2 = "删除成功后，app和后台都不显示该规格";
        m3 = "删除成功";
        type = "error";
      }
      this.$confirm(m1, m2, { type: type })
        .then(() => {
          that.loading = true;
          let para = {
            token: localStorage.getItem("api_token"),
            id: row.id,
            status: status
          };
          API.status_good_sku(para)
            .then(
              function(result) {
                that.loading = false;
                if (result && parseInt(result.key) === 1000) {
                  if (para.status == 3) {
                    that.typeOptions = null;
                  }
                  that.$message.success({
                    showClose: true,
                    message: m3,
                    duration: 1500
                  });
                  that.search();
                }
              },
              function(err) {
                that.loading = false;
                that.$message.error({
                  showClose: true,
                  message: err.toString(),
                  duration: 2000
                });
              }
            )
            .catch(function(error) {
              that.loading = false;
              that.$message.error({
                showClose: true,
                message: "请求出现异常",
                duration: 2000
              });
            });
        })
        .catch(() => {});
    },
    handleSearch() {
      this.page_size = 10;
      this.page_num = 1;
      this.search();
    },
    search() {
      let that = this;

      let params = {
        pageNum: that.page_num,
        pageSize: that.page_size,
        token: localStorage.getItem("api_token"),
        good_id: that.goodId
      };

      if (that.filters.status) {
        params.status = that.filters.status;
      }
      if (that.filters.num_status) {
        params.num_status = that.filters.num_status;
      }
      if (
        that.filters.keyword &&
        that.filters.keyword != null &&
        that.filters.keyword != ""
      ) {
        params.keyword = that.filters.keyword;
      }
      that.loading = true;
      API.good_sku_list(params)
        .then(
          function(result) {
            that.loading = false;
            if (result.key == 1000) {
              that.total_num = result.result.count;
              that.total_page = result.result.allPageNumber;
              if (result.result.list && result.result.list.length > 0) {
                //properties
                for (var i = 0; i < result.result.list.length; i++) {
                  var properties = JSON.parse(result.result.list[i].properties);
                  var propertyN = "";
                  for (var j = 0; j < properties.length; j++) {
                    propertyN =
                      propertyN +
                      properties[j].name +
                      "-" +
                      properties[j].value +
                      ";";
                  }
                  result.result.list[i].propertyN = propertyN;
                }
                that.tableData = result.result.list;
              } else {
                that.tableData = [];
              }
            }
          },
          function(err) {
            that.loading = false;
            that.$message.error({
              showClose: true,
              message: err.toString(),
              duration: 2000
            });
          }
        )
        .catch(function(error) {
          that.loading = false;
          that.$message.error({
            showClose: true,
            message: "请求出现异常",
            duration: 2000
          });
        });
    },
    jumpTo(url) {
      this.$router.push(url); //用go刷新
    },
    objectSpanMethod({ row, rowIndex }) {
      return "table_head";
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      this.search();
    }
  }
};
</script>

<style>
.table_head {
  background-color: #f8f8f8 !important;
  border-right: 1px solid #eee;
  border-bottom: 1px solid #eee;
  border-top: 1px solid #eee;
}

.main_content {
  position: absolute;
  left: 210px;
  top: 105px;
  right: 0;
  bottom: 0;
  background-color: #f2f2f2;
  padding: 0;
}

.cont_navs {
  background-color: #fff;
  width: 100%;
  height: 55px;
  box-sizing: border-box;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1);
  text-align: center;
  margin-bottom: 20px;
}
.cont_navs li {
  display: inline-block;
  line-height: 21px;
  padding: 17px 0;
  margin: 0 20px;
  height: 55px;
  color: #bbb;
  font-size: 15px;
  text-align: center;
  cursor: pointer;
}
.cont_navs li:hover {
  color: #409eff;
}

.ac_li {
  color: #409eff;
  border-bottom: solid 2px #409eff;
}
.contain_div {
  margin: 10px;
}
.cont_btns1 {
  float: left;
  margin: 0px 0px 20px 0;
}
.contain_header {
  background-color: #fff;
  padding: 10px;
}
.cont_btns1 li {
  display: inline-block;
}

.contain_body {
  background-color: #fff;
  margin-top: 20px;
  position: relative;
  padding-bottom: 35px;
}
.contain_body_head {
  display: block;
  padding: 10px 0 10px 10px;
  font-size: 16px;
  background-color: #f8f8f8;
}
.pageDiv {
  position: absolute;
  right: 0;
  bottom: 0;
}

.m-search {
  margin-bottom: -15px;
}
.el-button + .el-button {
  margin-left: 0px !important;
}

.pri-div {
  display: flex;
  width: 100%;
  justify-content: space-between;
}

.pri-div > div {
  width: 48%;
  border: 1px solid #dadada;
  border-radius: 10px;
  margin-bottom: 20px;
}
.guii-list {
  padding: 0 10px 10px 10px;
}
.guide-name {
  margin-top: 10px;
  margin-bottom: 10px;
}
.item-value span {
  background-color: #bbb;
  display: inline-block;
  width: 100px;
  padding: 5px 10px;
  cursor: pointer;
  margin-right: 10px;
  margin-top: 10px;
  text-align: center;
}

.guide-list > div {
  display: flex;
  justify-content: space-around;
  align-items: center;
}
.guide-list .el-input__inner {
  height: 27px;
  padding-right: 0px;
}
.guide-head {
  padding-top: 10px;
  background-color: #fafafa;
  border-top-right-radius: 10px;
  border-top-left-radius: 10px;
  margin-bottom: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/good/skuList.vue